/**
 * Mobile app prompt banner — disabled.
 *
 * Web is the only supported way to join a meeting. The previous bottom
 * banner that encouraged users to open the native app has been removed
 * (along with the Android-only prompts on the joining screen).
 */
export default function MobileAppBanner() {
  return null;
}
